import React from "react";

// Style \\
import "../../assets/styles/sections/meddical.scss";

// Icon \\
import { BiRightArrowAlt } from "react-icons/bi";

// Image \\
import meddical from "../../assets/images/meddical.svg";

const Meddical = () => {
  return (
    <section className="meddical">
      <div className="container">
        <div className="meddical_items">
          <div className="meddical_items_title">
            <h2>Welcome to Meddical</h2>
            <p className="title">A Great Place to Receive Care</p>
            <p className="desc">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
              placerat <br /> scelerisque tortor ornare ornare. Convallis felis
              vitae tortor augue. Velit nascetur <br /> proin massa in.
              Consequat faucibus porttitor enim et.
            </p>

            <a href="">
              <p>Learn More</p>
              <BiRightArrowAlt className="arrow-icon" />
            </a>
          </div>

          <div className="meddical_items_avatar">
            <div className="avatar_opacty">
              <img src={meddical} alt="meddical" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Meddical;
